import { Cell } from '@table-library/react-table-library/table';
import moment from 'moment';
import PayNowButton from './PayNowButton';

export const COLUMNS = (t) => [
    {
        label: t('invoices.date'),
        key: 'created_date',
        data: 'created_date',
        Component: Cell,
        renderCell: ({ data }) => (data ? moment(data).format('D MMM YYYY') : '-'),
    },
    {
        label: t('invoices.invoice_number'),
        key: 'id',
        data: 'id',
        Component: Cell,
    },
    {
        label: t('invoices.status'),
        key: 'status',
        data: 'status',
        Component: Cell,
        renderCell: ({ data }) => {
            const status = data?.toLowerCase();
            // Same green as .invoices-status.active for paid; the rest is Bootstrap's own
            // .alert-warning palette (public/css/app.css) so "pending" reads as a warning app-wide.
            const stylesByStatus = {
                paid: { color: '#33b1a5', backgroundColor: '#ebf6f7' },
                open: { color: '#664d03', backgroundColor: '#fff3cd' },
            };
            const labelsByStatus = {
                paid: t('invoices.status_paid'),
                open: t('invoices.status_pending_payment'),
            };
            const label = labelsByStatus[status] ?? (data ? data.charAt(0).toUpperCase() + data.slice(1) : data);
            return (
                <div
                    className={`invoices-status ${status === 'paid' ? 'active' : ''}`}
                    style={stylesByStatus[status]}
                >
                    {label}
                </div>
            );
        },
    },
    {
        label: t('invoices.description'),
        key: 'description',
        data: 'description',
        Component: Cell,
    },
    {
        label: t('invoices.payment'),
        key: 'amount_paid',
        data: 'amount_paid',
        Component: Cell,
        renderCell: ({ data }) =>
            new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data ?? 0),
    },
    {
        label: t('invoices.message'),
        key: 'message',
        data: 'message',
        Component: Cell,
    },
    {
        label: t('invoices.actions'),
        key: 'actions',
        data: 'actions',
        Component: Cell,
        renderCell: ({ item }) => {
            return (
                <div>
                    <a
                        className="btn"
                        rel="noreferrer"
                        href={item.url_pdf}
                        role="button"
                        target="_blank"
                        download
                        title={t('invoices.download')}
                    >
                        <i className="icofont-download" style={{ color: '#98A2B3' }}></i>
                    </a>
                    <a
                        className="btn"
                        rel="noreferrer"
                        href={`mailto:${item.mail}?subject=Invoice&body=${item.url_pdf}`}
                        role="button"
                        title={t('invoices.send_email')}
                    >
                        <i className="icofont-envelope" style={{ color: '#98A2B3' }}></i>
                    </a>
                    {item.is_payable && <PayNowButton invoiceId={item.invoice_id} t={t} />}
                </div>
            );
        },
    },
];
